module.exports = __webpack_public_path__ + "media/images/front/about/top_thumb_sp-577a45091784007f8f4bebf49001b469.jpg";